import 'src/modules/inventory';

const LookupPalletTag = gql`
  query LookupPalletTag($tagNumber: String!, $warehouseId: Int!) {
    palletTagLookup(tagNumber: $tagNumber, warehouseId: $warehouseId) {
      id
      tagNumber
      cartonQuantity
      weight
      lot {
        id
        slug
        warehouseId
        metrics {
          landedCost
        }
        product {
          id
          description
          commodityId
          commodity {
            name
          }
          organic
          countryOfOrigin
        }
      }
    }
  }
`;

const AddPalletTagToLineItem = gql`
  mutation AddPalletTagToLineItem($lineItemId: Int!, $input: AddPalletTagToLineItemInput!) {
    addPalletTagToLineItem(lineItemId: $lineItemId, input: $input) {
      palletTag {
        id
        tagNumber
        cartonQuantity
        weight
      }
      palletTagId
      deletedAt
      quantity
      weight
      lineItem {
        unitsPicked
        product {
          productId: id
        }
        lot {
          status
          id
          slug
          metrics {
            grossProfit
            landedCost
          }
          initialQuantity
          initialWeight
          warehouseId
          quantity

          lotOrderSources {
            workOrderId
          }

          product {
            productId: id
            description
            landedCost
            commodity {
              name
            }
          }
        }
      }
    }
  }
`;

const AddPalletTagToInventoryTransfer = gql`
  mutation AddPalletTagToInventoryTransfer($inventoryTransferId: Int!, $input: AddPalletTagToInventoryTransferInput!) {
    addPalletTagToInventoryTransfer(inventoryTransferId: $inventoryTransferId, input: $input) {
      palletTag {
        id
        tagNumber
        cartonQuantity
      }
      deletedAt
      quantity
      lotTransferItem {
        id
        unitsTransferred
        lot {
          ...InventoryTransferLotRowFragment
        }
      }
    }
  }
`;

// TODO: Add response when we don't solve this by refetching
const AddPalletTagToProductionRun = gql`
  mutation AddPalletTagToProductionRun($productionRunId: Int!, $input: AddPalletTagToProductionRunInput!) {
    addPalletTagToProductionRun(productionRunId: $productionRunId, input: $input) {
      palletTagId
    }
  }
`;

export const CreateLineItemFromPalletTag = gql`
  mutation createLineItemFromPalletTag($input: CreateLineItemInput!) {
    createLineItem(input: $input) {
      ...LineItemAttributes
    }
  }
`;

export default {
  LookupPalletTag,
  AddPalletTagToLineItem,
  AddPalletTagToInventoryTransfer,
  AddPalletTagToProductionRun,
  CreateLineItemFromPalletTag,
};
